import React, { useState } from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BrandLogo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { LogOut, Menu, X, Globe } from "lucide-react";

export default function DashShell({ items, title }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const SidebarBody = (
    <div className="flex h-full flex-col">
      <div className="border-b border-slate-800 px-5 py-4"><BrandLogo light /></div>
      <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
        {items.map((it) => (
          <NavLink key={it.to} to={it.to} end={it.end} onClick={() => setOpen(false)}
            data-testid={`side-${it.to.split("/").pop() || "root"}`}
            className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
              isActive ? "bg-clinical text-white" : "text-slate-300 hover:bg-white/5 hover:text-white"}`}>
            <it.icon className="h-4.5 w-4.5" /> {it.label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-slate-800 p-3">
        <div className="px-2 pb-2">
          <p className="truncate text-sm font-medium text-white">{user?.name}</p>
          <p className="truncate text-xs text-slate-400">{user?.role}</p>
        </div>
        <Button variant="ghost" size="sm" onClick={() => nav("/")} className="w-full justify-start text-slate-300 hover:text-white">
          <Globe className="mr-2 h-4 w-4" /> Public site
        </Button>
        <Button variant="ghost" size="sm" data-testid="logout-btn" onClick={() => { logout(); nav("/"); }}
          className="w-full justify-start text-slate-300 hover:text-white">
          <LogOut className="mr-2 h-4 w-4" /> Log out
        </Button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50">
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-64 bg-navy lg:block">{SidebarBody}</aside>
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 left-0 w-64 bg-navy">{SidebarBody}</aside>
        </div>
      )}
      <div className="lg:pl-64">
        <header className="sticky top-0 z-30 flex items-center justify-between border-b border-slate-200 bg-white/95 px-4 py-3 backdrop-blur-md lg:px-8">
          <button className="lg:hidden" onClick={() => setOpen(true)} data-testid="dash-mobile-toggle">
            <Menu className="h-6 w-6 text-navy" />
          </button>
          <h1 className="font-heading text-lg font-semibold text-navy">{title}</h1>
          <div className="w-6 lg:hidden" />
        </header>
        <main className="px-4 py-6 lg:px-8 lg:py-8"><Outlet /></main>
      </div>
    </div>
  );
}
